const Events = [{
        value: 'user.created',
        display_name: 'User Created Event'
    },
    {
        value: 'user.deleted',
        display_name: 'User Deleted Event'
    },
    {
        value: 'user.email.verified',
        display_name: 'User Email Verified Event'
    }
]



export default Events;